import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import qs from "qs";
import { useDispatch } from "react-redux";
import { useSigninWithCode } from "../utils/authHelpers";
import { SET_WARNING, CLOSE_WARNING } from "../actions/type";
import {
  default as ACCESS_LEVELS,
  ADMINS,
  STUDENT
} from "../config/accessLevels";

const MyBestUserLogin = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const signinWithCode = useSigninWithCode();
  const dispatch = useDispatch();

  useEffect(() => {
    const search = qs.parse(location.search, { ignoreQueryPrefix: true });

    signinWithCode(search.code)
      .then(({ data }) => {
        const roles = data.signinWithCode.me.roles || [];

        // If user has no roles, show warning and redirect to home
        if (roles.length === 0) {
          dispatch({
            type: SET_WARNING,
            payload: {
              alert:
                "身分認證錯誤!\n請洽詢您的校長索取登入邀請碼,或是聯繫教務及工程師\n\nIdentity error!\nPlease check invitation code with your principal or Melody consultants.",
              confirm: () => {
                dispatch({ type: CLOSE_WARNING, payload: {} });
                navigate("/");
              }
            }
          });
          return;
        }

        // Check localStorage first (persists after logout)
        let previousUrl = localStorage.getItem("tabletReturnPath");
        if (previousUrl) {
          // Clear it after reading
          localStorage.removeItem("tabletReturnPath");
        }

        // Fallback to sessionStorage if no tabletReturnPath
        if (!previousUrl) {
          previousUrl = sessionStorage.getItem("previousURL");

          if (previousUrl) {
            sessionStorage.removeItem("previousURL");
          }
        }

        // Determine the user's role-based route
        const userRoleRoute = roles.some((role) =>
          ACCESS_LEVELS[ADMINS].includes(role)
        )
          ? "admin"
          : roles.some((role) => ACCESS_LEVELS[STUDENT].includes(role))
            ? "student"
            : "teacher";

        if (!previousUrl) {
          console.log(
            "[MyBestUserLogin] No previousUrl, navigating to:",
            `/${userRoleRoute}`
          );
          navigate(`/${userRoleRoute}`);
        } else {
          // Transform the path to match the logged-in user's role
          // Replace the role segment (admin/teacher/student) with the actual user's role
          const pathSegments = previousUrl.split("/").filter(Boolean);

          if (pathSegments.length > 0) {
            const firstSegment = pathSegments[0];

            // Check if first segment is a role (admin/teacher/student)
            if (
              firstSegment === "admin" ||
              firstSegment === "teacher" ||
              firstSegment === "student"
            ) {
              // Replace with user's actual role
              pathSegments[0] = userRoleRoute;
              previousUrl = "/" + pathSegments.join("/");
            }
          }

          navigate(previousUrl);
        }
      })
      .catch((error) => {
        dispatch({
          type: SET_WARNING,
          payload: {
            alert: error.message,
            confirm: () => {
              dispatch({ type: CLOSE_WARNING, payload: {} });
              navigate("/");
            }
          }
        });
      });
  }, [signinWithCode, navigate, location, dispatch]);

  return null;
};

export default MyBestUserLogin;
